import { oc } from '@orpc/contract';
import { compatibilityConfigSchema, updateCompatibilityInputSchema } from '../schemas/config.schemas.js';
export const updateCompatibilityContract = oc
    .route({
    method: 'PUT',
    path: '/config/compatibility/{id}',
    tags: ['Config'],
    summary: 'Replace a compatibility check’s definition and status',
    description: 'MANAGER only. Per plan §12.3 a temperature spread warns rather than blocks, which is a `onFail` value here, not code.',
})
    .input(updateCompatibilityInputSchema)
    .output(compatibilityConfigSchema);
//# sourceMappingURL=update-compatibility.contract.js.map